import { ref } from 'vue';
import type { CampaignLinkParticipations } from './Types';

export const participations = ref<CampaignLinkParticipations>({});

export const getParticipations = () => {
  return participations.value;
};

export const setParticipations = (campaignId: number | string, setValue: CampaignLinkParticipations) => {
  participations.value[`${campaignId}`] = setValue[`${campaignId}`];
};
